import { GridItem } from '@bnnvara/grids';
import { formatDate } from '@bnnvara/helpers';
import BaseMetaBlock from '@bnnvara/metablocks';
import { Heading } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React from 'react';

import Link from '../components/Link';

const formatReadingTime = (minutes) => {
  const notation = minutes === 1 ? 'minuut' : 'minuten';

  return `${minutes} ${notation}`;
};

const ComposableArticleHeader = ({
  title,
  publishDate,
  readingTime,
  categories,
  viewCount,
}) => {
  const categoryList = categories.map((category, index) => (
    <Link href={`rubrieken/${category.slug}`} key={category.slug}>
      <a>
        {category.name}
        <span key={`comma-${category.name}`}>
          {index < categories.length - 1 ? ', ' : null}
        </span>
      </a>
    </Link>
  ));

  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      <Heading element="h1" variant="one">
        {title}
      </Heading>
      <BaseMetaBlock
        categories={categoryList}
        publicationDate={formatDate(publishDate)}
        duration={`leestijd ${formatReadingTime(readingTime)}`}
        viewCount={viewCount}
      />
    </GridItem>
  );
};

ComposableArticleHeader.defaultProps = {
  categories: [],
};

ComposableArticleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,
  readingTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  viewCount: PropTypes.number,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ),
};

export default ComposableArticleHeader;
